import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLACK } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track16CBlack = ({ state, workState, onLabelClick }) => (
	<g id="Track16CBlack" transform="translate(2349.000000, 423.000000)" className="track">
		<g id="line"
			 transform="translate(0.138327, 0.932938)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
			 strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<polyline points="13.659426 37.3705498 38.0990905 117.276032 62.4227786 173.435668"/>
			<line x1="2" y1="9.66605897e-14" x2="10.5509958" y2="27.2075372"/>

			<TrackArrow
				transform="translate(9.717660, 24.728336) rotate(-109.000000) translate(-9.717660, -24.728336) "
				points="13.7176598 32.7283361 5.71765977 24.7283361 13.7176598 16.7283361"
			/>

			{/*<line className="connector" x1="62.3616731" y1="173.567062" x2="155.626108" y2="261.486168"/>*/}
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track16CBlack')}
			coords="23.561105, 101.368606"
			text="16C"
			textCoordsX="6.9609375"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
		/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track16CBlack')}
			coords="70.561105, 188.368606"
			text="16C"
			textCoordsX="6.9609375"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
		/>
	</g>
);


Track16CBlack.propTypes = trackPropTypes;

export default Track16CBlack;
